import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { PageMeta } from '@sirajoptic/shared';
import { Button } from './button';
import { entier } from '@/lib/format';

/** Pagination serveur : on n'affiche jamais plus que la page demandée. */
export function Pagination({
  meta,
  onPage,
  libelle = 'résultats',
}: {
  meta: PageMeta;
  onPage: (page: number) => void;
  libelle?: string;
}) {
  const pages = Math.max(1, Math.ceil(meta.total / meta.limit));
  if (meta.total === 0) return null;

  const debut = (meta.page - 1) * meta.limit + 1;
  const fin = Math.min(meta.page * meta.limit, meta.total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-line px-4 py-3">
      <p className="text-xs text-ink-muted tabular">
        {entier(debut)}–{entier(fin)} sur {entier(meta.total)} {libelle}
      </p>

      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          disabled={meta.page <= 1}
          onClick={() => onPage(meta.page - 1)}
          icone={<ChevronLeft aria-hidden className="h-3.5 w-3.5" />}
        >
          Précédent
        </Button>
        <span className="px-2 text-xs text-ink-muted tabular">
          Page {entier(meta.page)} / {entier(pages)}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={meta.page >= pages}
          onClick={() => onPage(meta.page + 1)}
        >
          Suivant
          <ChevronRight aria-hidden className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
